import NavTabsComponent from './NavTabs'
import Link from './Link'

const NavTabs = NavTabsComponent
NavTabs.Link = Link

export default NavTabs
